<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">Nanny Code of Conduct</h3>
      <hr>
      <h4>A. Punctuality and Reliability</h4>
      <p>We value punctuality and reliability above all else. When interviewing with a GCN team member or one of our families, please arrive early or on time. We understand commuting around Chicagoland comes with weather issues, traffic, and parking grievances, so give yourself extra time to accommodate any issues that may arise. GCN understands situations arise, but in general, do not tolerate tardiness or last-minute cancellations.</p>
      <h4>B. Responsiveness</h4>
      <p>We truly value our nannies and are happy to provide a free service for professional nannies and household managers. We work diligently to find our nannies great positions and for this to work smoothly, we expect our nannies to answer our emails, texts, and/or calls in a reasonable amount of time. The faster we can get ahold of you to schedule interviews and trials, the quicker you will be hired.</p>
      <h4>C. Transparency</h4>
      <p>The nanny industry is very intimate profession. Our clients trust our judgement when placing people to work in their homes. Because of this, we are very thorough with our reference and background checks. We understand that sometimes former positions may have ended with hard feelings and things from the past surface on background checks. We appreciate when our candidates are honest and transparent from the beginning about anything that will come up during the screening process.</p>
      <h4>D. Self-Presentation</h4>
      <p>Our families come to us searching for professional, career nannies and other staff to join their household. Please keep this in mind throughout the interview process. We agree that work out clothes are great, but please refrain from wearing them to an interview. Jeans are fine.</p>
      <h4>E. Contact with Families</h4>
      <p>During the interview and trial process, all communication with our clients should go through a GCN team member. We respect our clients’ privacy, as well as yours, by not giving out nannies or families contact information. Once work agreement is signed, everyone’s contact information will be included at the top of the agreement for your convenience.</p>
      <hr>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'; text-transform: none;">{{ signature }}</h4>
      <h4 v-if="!signature">___________________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label v-if="!signature" class="mt-1">Please type your name.</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>
      <!-- <p>{{ document }}</p> -->
      <!-- <button @click="deleteDocument()" class="mylisting-button danger-button">Delete</button> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteDocument() {
      axios.delete(`/api/documents/${this.document.id}/`)
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/candidates/documents/CodeOfConduct.vue